import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import Box from "@material-ui/core/Box";
import axios from 'axios';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MetaTags from 'react-meta-tags';

import cookieName from '../../helpers/cookiesDeclaration';
import GeneralStyles from '../../styles/GeneralStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Girl from '../../assets/images/academyGirl.png';
// import Test from '../../assets/images/test.webp';
import Test from '../../assets/images/load.gif';
import LogoGif from '../../assets/images/Logo_GIF.gif';


const useGeneralStyles = GeneralStyles;

function Academy(props) {
    const [cookies, setCookie] = useCookies([cookieName]);
    const classesG = useGeneralStyles();
    const user = cookies[cookieName];

    // const matchTablet = useMediaQuery('(max-width:790px)');
    const matchMobile = useMediaQuery('(max-width:600px)');

    const [loading, setLoading] = useState(false);
    const [home, setHome] = useState(null);
    // const match = useMediaQuery('(min-width:600px)');

    useEffect(() => {
        setLoading(true);
        axios
            .get(
                `${process.env.REACT_APP_GATEWAY_END_POINT}/home`)
            .then((response) => {
                setHome(response.data);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(true);
            });
    }, []);


    const redirectPage = (params) => {
        setCookie(cookieName, JSON.stringify(user), { path: '/' });

        const { history, location } = props;
        const { from } = location.state || {
            from: {
                pathname: params,
            },
        };
        history.push(from);
    };

    const replace = (param) => {
        var value = '';

        if (param !== '' && param !== null && param !== undefined) {
            value = param.replace(`${process.env.REACT_APP_GATEWAY_PATH_REPLACE}`, `${process.env.REACT_APP_GATEWAY_PATH_S3}`);
        }

        return value;
    }

    return (
        <React.Fragment>
            {loading && (
                <div className={classesG.divProgress}>
                    <CircularProgress size={68} className={classesG.progress} />
                </div>
            )}
            {!loading && (
                <React.Fragment>
                    {home === null || home === undefined ? '' : (
                        <React.Fragment>
                            <MetaTags>
                                <title>{home.Page_title}</title>
                                <meta name="description" content={home.Page_description} />
                            </MetaTags>
                            <div className={classesG.container}>
                                <section className={classesG.sectionHomeVideo}>
                                    <div className={classesG.workSecondSectionContent}>
                                        <div className={classesG.workSectionBox}>
                                            <div className={classesG.academyHeaderGif}>
                                                <div>
                                                    <img 
                                                     src={LogoGif}
                                                     alt={'LogoGif'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.academyBlackBackground}></div>
                                    <div className={classesG.academyContent}>
                                        <div className={classesG.homeThirdSectionBox}>
                                            <div className={classesG.academyBlackParagraph}>
                                                <p>
                                                    If your career goal is goals, goals goals… then you’ve come to the right place. The the Footballco
                                                    Academy is an internship and creative placement programme open to anyone who is passionate
                                                    about working in the football media and content business… and want to do it with the very best in the business.
                                                </p>
                                            </div>
                                        </div>
                                        <div className={classesG.homeThirdSectionBox_op2}>
                                            <div className={classesG.academyBlackSectionText}>
                                                <h2>IF YOU’VE GOT GAME, THEN WE’VE GOT ROLES.</h2>
                                                <p>
                                                    …eight of them in fact, spread across
                                                    three different departments within
                                                    our business.
                                                </p>
                                                <div className={classesG.academyListContent}>
                                                    <h3>
                                                        CONTENT
                                                    </h3>
                                                    <p>
                                                        This is our editorial team and the largest department in our business,
                                                        responsible for keeping our global football-loving audience informed and entertained.
                                                    </p>
                                                </div>
                                                <div className={classesG.academyListContent}>
                                                    <h3>
                                                        CREATIVE
                                                    </h3>
                                                    <p>
                                                        Our creative department services the commercial side of business,
                                                        creating branded content for the best brands in the world, across every platform imaginable.
                                                    </p>
                                                </div>
                                                <div className={classesG.academyListContent}>
                                                    <h3>
                                                        CLIENT SERVICES
                                                    </h3>
                                                    <p>
                                                        The business side of things is taken care of by our client services team,
                                                        ensuring everything happens on time, within budget and above expectations.
                                                    </p>
                                                </div>
                                            </div>

                                            <div className={classesG.academySectionImage}>
                                                <img
                                                    className={classesG.imageHome_op2}
                                                    src={Girl}
                                                    alt={'academyGirl'}
                                                />
                                                <p>
                                                    “Have fun with it and take in the experiences even
                                                    if a certain day doesn’t go as planned, realising it’s
                                                    okay to learn and make mistakes and keep growing”

                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className={classesG.section}>
                                    <div className={classesG.thirdSectionContent}>
                                        <div className={classesG.homeThirdSectionBox}>
                                            <div className={classesG.academyWhiteParagraph}>
                                                <h2>HOW DO YOU APPLY </h2>
                                                <h2>FOR THE ACADEMY?</h2>
                                            </div>
                                        </div>
                                        <div className={classesG.homeThirdSectionBox}>
                                            <div className={classesG.academyWhiteSectionBox}>
                                                <div className={classesG.academyContentBox}>
                                                    <div className={classesG.academyBorderBox}>
                                                        <p>1</p>
                                                        <br />
                                                        <p>
                                                            ANSWER A <br />
                                                            SIMPLE <br />
                                                            QUESTION
                                                        </p>
                                                    </div>
                                                    <p>
                                                        We want to know why a place in
                                                        our academy means everything
                                                        to you? <br /><br />

                                                        And we want you to answer it in
                                                        your own unique way.
                                                    </p>
                                                </div>

                                                <div className={classesG.academyContentBox}>
                                                    <div className={classesG.academyBorderBox}>
                                                        <p>2</p>
                                                        <br />
                                                        <p>
                                                            SEND <br />
                                                            AN <br />
                                                            EMAIL
                                                        </p>
                                                    </div>
                                                    <p>
                                                        <a href='mailto:academy@footballco.com'>academy@footballco.com</a> is the address. <br /><br />

                                                        What you choose to send to us is a completely up to you.
                                                        So long as it answers the question, you can send us a video,
                                                        tell us a story, upload a photo, move us with words.<br />
                                                        Get thinking. Get creative.
                                                        Get the job.
                                                    </p>
                                                </div>

                                                <div className={classesG.academyContentBox}>
                                                    <div className={classesG.academyBorderBox}>
                                                        <p>3</p>
                                                        <br />
                                                        <p>
                                                            ATTEND <br />
                                                            AN <br />
                                                            INTERVIEW <br />
                                                        </p>
                                                    </div>
                                                    <p>
                                                        Standout applicants will be invited to attend an Academy open day at our offices in central London
                                                        (on us of course). <br /><br />

                                                        You’ll meet the team, find out more about the role and be get the opportunity to further
                                                        impress the Footballco Academy scouts.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default (Academy);